import type { ComponentProps } from "react";
import { ChevronDown } from "lucide-react";
import { Accordion as AccordionPrimitive } from "radix-ui";

export function Accordion(props: ComponentProps<typeof AccordionPrimitive.Root>) {
  return <AccordionPrimitive.Root data-slot="accordion" {...props} />;
}

export function AccordionItem({ className = "", ...props }: ComponentProps<typeof AccordionPrimitive.Item>) {
  return <AccordionPrimitive.Item className={`area-accordion__item ${className}`.trim()} data-slot="accordion-item" {...props} />;
}

export function AccordionTrigger({ children, className = "", ...props }: ComponentProps<typeof AccordionPrimitive.Trigger>) {
  return (
    <AccordionPrimitive.Header className="area-accordion__header">
      <AccordionPrimitive.Trigger className={`area-accordion__trigger ${className}`.trim()} data-slot="accordion-trigger" {...props}>
        {children}
        <ChevronDown aria-hidden="true" />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
}

export function AccordionContent({ children, className = "", ...props }: ComponentProps<typeof AccordionPrimitive.Content>) {
  return (
    <AccordionPrimitive.Content className={`area-accordion__content ${className}`.trim()} data-slot="accordion-content" {...props}>
      <div>{children}</div>
    </AccordionPrimitive.Content>
  );
}
